/**
 * 格式化工具函数
 * 统一处理金额、数字等格式化需求
 */

/**
 * 格式化金额 - 分转元
 * @param amount 金额（单位：分）
 * @returns 格式化后的金额字符串，如："99,999.99"
 */
export const formatAmount = (amount: number): string => {
    const yuan = amount / 100
    return new Intl.NumberFormat('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(yuan)
} 